module.exports = __webpack_public_path__ + "static/media/section10.37fd8237.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quiz/image/section10.png
// module id = 306
// module chunks = 0